import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  es: {
    nav_dashboard: "Dashboard",
    nav_inbox: "Bandeja",
    nav_human_inbox: "Bandeja humano",
    nav_contacts: "Contactos",
    nav_campaigns: "Campanas",
    nav_orders: "Pedidos",
    nav_payments: "Comprobantes",
    nav_complaints: "Reclamos",
    nav_calendar: "Citas",
    nav_agent: "Agente IA",
    nav_knowledge: "Conocimiento",
    nav_templates: "Plantillas",
    nav_analytics: "Analitica",
    nav_settings: "WhatsApp",
    nav_preferences: "Preferencias",
    seed_demo: "Cargar datos demo",
    logout: "Cerrar sesion",
    prefs_title: "Preferencias",
    prefs_subtitle: "Personaliza tu experiencia en Wazco Express.",
    prefs_appearance: "Apariencia",
    prefs_theme: "Tema",
    prefs_theme_dark: "Oscuro",
    prefs_theme_light: "Claro",
    prefs_language: "Idioma",
    prefs_lang_es: "Espanol",
    prefs_lang_en: "English",
    prefs_danger: "Zona peligrosa",
    prefs_delete_title: "Eliminar cuenta",
    prefs_delete_owner_hint: "Esto borrara permanentemente tu workspace, todos sus contactos, mensajes, pedidos, citas y miembros del equipo. Esta accion no se puede deshacer.",
    prefs_delete_member_hint: "Esto borrara tu acceso al workspace. Los datos del negocio permaneceran.",
    prefs_delete_confirm: "Escribe ELIMINAR para confirmar",
    prefs_delete_button: "Eliminar cuenta definitivamente",
    prefs_delete_cta: "Eliminar cuenta",
    hi_title: "Bandeja humano",
    hi_subtitle: "Conversaciones marcadas para atencion o revision de una persona.",
    hi_empty: "Nada pendiente. Todo esta bajo control.",
    hi_reason: "Motivo",
    hi_open: "Abrir chat",
    hi_resolve: "Marcar resuelto",
    hi_escalated_at: "Escalado",
    hi_assign: "Asignar a",
    hi_unassigned: "Sin asignar",
    hi_urgency_high: "Alta urgencia",
    hi_urgency_medium: "Urgencia media",
    hi_urgency_low: "Urgencia baja",
    dash_kicker: "Panel de control",
    dash_title: "Dashboard",
    dash_contacts: "Contactos",
    dash_contacts_sub: "leads activos",
    dash_messages: "Mensajes",
    dash_messages_sub: "via IA",
    dash_conversion: "Conversion",
    dash_conversion_sub: "ventas ganadas",
    dash_appointments: "Citas",
    dash_appointments_sub: "agendadas",
    dash_activity: "Actividad",
    dash_activity_title: "Mensajes ultimos 7 dias",
    dash_funnel: "Embudo",
    dash_pipeline: "Pipeline",
    dash_recent: "Recientes",
    dash_active_convos: "Conversaciones activas",
    dash_view_inbox: "Ver bandeja",
    dash_no_convos: "Sin conversaciones.",
    dash_loading: "Cargando dashboard...",
    stage_nuevo: "Nuevos",
    stage_contactado: "Contactados",
    stage_calificado: "Calificados",
    stage_negociacion: "Negociacion",
    stage_ganado: "Ganados",
    stage_perdido: "Perdidos",
    inbox_kicker: "Conversaciones",
    inbox_title: "Bandeja",
    inbox_search: "Buscar contacto...",
    inbox_empty: "Sin conversaciones",
    inbox_notes: "Notas internas",
    inbox_notes_placeholder: "Nota privada visible solo por el equipo...",
    inbox_notes_add: "Agregar nota",
    inbox_notes_empty: "Sin notas internas todavia.",
    crm_kicker: "Base de clientes",
    crm_title: "Contactos",
    crm_new: "Nuevo contacto",
    crm_search: "Buscar por nombre o telefono...",
    ana_kicker: "Metricas",
    ana_title: "Analitica",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
  },
  en: {
    nav_dashboard: "Dashboard",
    nav_inbox: "Inbox",
    nav_human_inbox: "Human inbox",
    nav_contacts: "Contacts",
    nav_campaigns: "Campaigns",
    nav_orders: "Orders",
    nav_payments: "Payments",
    nav_complaints: "Complaints",
    nav_calendar: "Appointments",
    nav_agent: "AI Agent",
    nav_knowledge: "Knowledge",
    nav_templates: "Templates",
    nav_analytics: "Analytics",
    nav_settings: "WhatsApp",
    nav_preferences: "Preferences",
    seed_demo: "Load demo data",
    logout: "Sign out",
    prefs_title: "Preferences",
    prefs_subtitle: "Personalize your Wazco Express experience.",
    prefs_appearance: "Appearance",
    prefs_theme: "Theme",
    prefs_theme_dark: "Dark",
    prefs_theme_light: "Light",
    prefs_language: "Language",
    prefs_lang_es: "Espanol",
    prefs_lang_en: "English",
    prefs_danger: "Danger zone",
    prefs_delete_title: "Delete account",
    prefs_delete_owner_hint: "This will permanently erase your workspace, all contacts, messages, orders, appointments and team members. This cannot be undone.",
    prefs_delete_member_hint: "This will remove your access to the workspace. Business data will remain.",
    prefs_delete_confirm: "Type DELETE to confirm",
    prefs_delete_button: "Delete account permanently",
    prefs_delete_cta: "Delete account",
    hi_title: "Human inbox",
    hi_subtitle: "Conversations flagged for human attention or review.",
    hi_empty: "Nothing pending. All under control.",
    hi_reason: "Reason",
    hi_open: "Open chat",
    hi_resolve: "Mark resolved",
    hi_escalated_at: "Escalated",
    hi_assign: "Assign to",
    hi_unassigned: "Unassigned",
    hi_urgency_high: "High urgency",
    hi_urgency_medium: "Medium urgency",
    hi_urgency_low: "Low urgency",
    dash_kicker: "Control panel",
    dash_title: "Dashboard",
    dash_contacts: "Contacts",
    dash_contacts_sub: "active leads",
    dash_messages: "Messages",
    dash_messages_sub: "via AI",
    dash_conversion: "Conversion",
    dash_conversion_sub: "won deals",
    dash_appointments: "Appointments",
    dash_appointments_sub: "booked",
    dash_activity: "Activity",
    dash_activity_title: "Messages last 7 days",
    dash_funnel: "Funnel",
    dash_pipeline: "Pipeline",
    dash_recent: "Recent",
    dash_active_convos: "Active conversations",
    dash_view_inbox: "View inbox",
    dash_no_convos: "No conversations yet.",
    dash_loading: "Loading dashboard...",
    stage_nuevo: "New",
    stage_contactado: "Contacted",
    stage_calificado: "Qualified",
    stage_negociacion: "Negotiation",
    stage_ganado: "Won",
    stage_perdido: "Lost",
    inbox_kicker: "Conversations",
    inbox_title: "Inbox",
    inbox_search: "Search contact...",
    inbox_empty: "No conversations",
    inbox_notes: "Internal notes",
    inbox_notes_placeholder: "Private note visible to the team only...",
    inbox_notes_add: "Add note",
    inbox_notes_empty: "No internal notes yet.",
    crm_kicker: "Customer base",
    crm_title: "Contacts",
    crm_new: "New contact",
    crm_search: "Search by name or phone...",
    ana_kicker: "Metrics",
    ana_title: "Analytics",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
  },
};

const I18nCtx = createContext({ lang: "es", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ventai_lang") || "es");
  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("ventai_lang", lang);
  }, [lang]);
  const setLang = (l) => setLangState(l === "en" ? "en" : "es");
  const t = (k) => (DICT[lang] && DICT[lang][k]) || DICT.es[k] || k;
  return <I18nCtx.Provider value={{ lang, t, setLang }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
